import axiosHttp from "services/axiosHttp";
import moment from "moment";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchSegmentPriceBookList = createAsyncThunk("fetchSegmentPriceBookList", async ({ filters, page, limit }, { rejectWithValue }) => {
	let start_date = "";
	let end_date = "";

	if (filters?.range?.length === 2) {
		start_date = moment(filters.range[0].$d).format("YYYY-MM-DD");
		end_date = moment(filters.range[1].$d).format("YYYY-MM-DD");
	}

	const params = new URLSearchParams({
		page: page,
		limit: limit,
		keyword: filters?.keyword ?? "",
		status_id: filters?.status_id ?? "",
		category_id: filters?.category_id ?? "",
		customer_segment_id: filters?.customer_segment_id ?? "",
		start_date: start_date,
		end_date: end_date,
		channel_uuid: filters?.channel_uuid ?? "",
	});

	try {
		const response = await axiosHttp.get(`price-book/segments?${params}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong while fetching the segment price book list");
	}
});

const SegmentPriceBookListSlice = createSlice({
	name: "SegmentPriceBookListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchSegmentPriceBookList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchSegmentPriceBookList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage || 1;
			state.total = action.payload.total || 0;
		});

		builder.addCase(fetchSegmentPriceBookList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || action.error.message || "Unknown error occurred";
		});
	},
});

export default SegmentPriceBookListSlice.reducer;
